import * as angular from 'angular';
import ErrorMessageBridge from './ErrorMessageBridge';

angular
  .module('flowingly.components')
  .component('errorMessage', ErrorMessageBridge);
